import React, { Component } from "react";
import HeadBar from "./common/HeadBar";
import "../style/selfie.scss";
import selfie from "../image/selfie2.gif";
import { routePage } from "../utils/routePage";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";

class Selfie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ad: getAd(),
    };
  }

  render() {
    let { history, location } = this.props;
    let { ad } = this.state;
    return (
      <React.Fragment>
        <div className="selfie-page">
          <HeadBar {...this.props} />
          <div className="selfie-box">
            <h1>
              Ensure your camera is set up correctly and functioning as
              expected.
            </h1>
            <h2>Take the photo in a well-lit area with minimal shadows.</h2>
            <h2>
              Our advanced verification systems detect and prevent the use of
              altered, manipulated, or synthetic images.
            </h2>
            <div className="gif-box">
              <img src={selfie} alt="" />
            </div>
            <div
              className="btn"
              onClick={() => routePage(history, ad, "/selfieInfo")}
            >
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Selfie;
